// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3NMan","detailsBorder":"styles_detailsBorder__gDTlE"};